import { useEffect, useState } from "react";

const CountUpNumber = ({ value, duration = 1000, formatter }) => {
  const [displayValue, setDisplayValue] = useState(0);

  useEffect(() => {
    let start = 0;
    let startTime = null;

    const step = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      const current = start + (value - start) * progress;
      setDisplayValue(current);

      if (progress < 1) {
        requestAnimationFrame(step);
      }
    };

    requestAnimationFrame(step);
  }, [value, duration]);

  return (
    <span>
      {formatter
        ? formatter(displayValue)
        : Math.floor(displayValue).toLocaleString()}
    </span>
  );
};

export default CountUpNumber;
